import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomFonts, getGoogleFonts } from 'ContentData/selectors/fonts';
import { fetchCustomFont, fetchFont } from 'ContentData/actions/Fonts';
import { FONT_SETS } from 'ContentUtils/constants/Fonts';
import { loadCustomFontStyle, loadFontStylesheet } from '../../components/cmv2/fontPicker/utils';
import { FONTS_BASE_KEY } from '../../constants/GlobalStyles';
import { getLoadableFonts } from '../../components/cmv2/utils/globalStyles';
import { getFieldFromKey } from '../../components/cmv2/utils';
import { getDeepValue } from 'ContentUtils/helpers/ObjectHelpers';
export const useLoadFontStyles = ({
  fields,
  globalStyles
}) => {
  const dispatch = useDispatch();
  const customFonts = useSelector(getCustomFonts);
  const googleFonts = useSelector(getGoogleFonts);
  const fontFields = useMemo(() => {
    const fontFieldsGroup = getFieldFromKey(fields, FONTS_BASE_KEY);
    return (fontFieldsGroup === null || fontFieldsGroup === void 0 ? void 0 : fontFieldsGroup.children) || [];
  }, [fields]);
  const fontOverrides = useMemo(() => {
    return getDeepValue(globalStyles, FONTS_BASE_KEY);
  }, [globalStyles]);
  const fontsToLoad = useMemo(() => {
    return getLoadableFonts(fontFields, fontOverrides);
  }, [fontFields, fontOverrides]);
  const loadCustomFont = useCallback(async (fontValue, onFontLoad) => {
    const {
      font: fontFamily,
      fontId
    } = fontValue;
    if (!fontFamily || !fontId) return;
    let customFont = customFonts[fontFamily];
    if (!customFont) {
      customFont = await dispatch(fetchCustomFont(fontId));
    }
    loadCustomFontStyle(customFont, onFontLoad);
  }, [customFonts, dispatch]);
  const loadGoogleFont = useCallback(async (fontValue, onFontLoad) => {
    const {
      font: fontFamily
    } = fontValue;
    if (!fontFamily) return;
    let googleFont = googleFonts[fontFamily];
    if (!googleFont) {
      googleFont = await dispatch(fetchFont(fontFamily));
    }
    loadFontStylesheet(fontFamily, googleFont.variants, {
      onFontLoad,
      useCache: false
    });
  }, [googleFonts, dispatch]);
  const loadFontStyles = useCallback(async (fontValue, onFontLoad) => {
    const {
      font_set: fontSet
    } = fontValue;
    switch (fontSet) {
      case FONT_SETS.GOOGLE:
        {
          await loadGoogleFont(fontValue, onFontLoad);
          break;
        }
      case FONT_SETS.BRANDING:
        {
          await loadCustomFont(fontValue, onFontLoad);
          break;
        }
      default:
        {
          onFontLoad === null || onFontLoad === void 0 || onFontLoad();
        }
    }
  }, [loadCustomFont, loadGoogleFont]);

  // TODO: remove unused font styles when font is changed

  return useMemo(() => {
    return {
      fontsToLoad,
      loadFontStyles
    };
  }, [fontsToLoad, loadFontStyles]);
};